import React, { memo, useContext } from "react";

import { TextElement } from "@/components/ui-kit/TextElement/TextElement";
import SearchContext from "@/context/SearchContext";
import { LinkedItem } from "@/types/search";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";

import styles from "./LinkedItems.module.scss";

export interface LinkedItemsProps {
  title?: string;
  items?: LinkedItem[];
  onClick: (event: React.MouseEvent<HTMLButtonElement>, item: LinkedItem) => void;
}

// ------------------- Component -------------------

const LinkedItemsComponent: React.FC<LinkedItemsProps> = ({ title, items, onClick }) => {
  const { searchState, defaultFAQs, search } = useContext(SearchContext);
  const links: LinkedItem[] = items && items.length ? items : defaultFAQs;

  return (
    <div>
      {title && (
        <TextElement
          text={title}
          className={cn(" title--xsmall text-master-base-black", styles.titleFont)}
        />
      )}
      <ul>
        {links.map((item, index) => {
          const text = item?.question || item?.title;
          if (!text) return null;

          const key = item?.id || item?.objectID || index;

          return (
            <li key={key} className="mt-2 md:mt-4">
              <button
                onClick={(e) => {
                  GA4.onSearchClicked({
                    search_term: search,
                    name: "Search",
                    location: "navigation",
                    state: searchState,
                    text,
                    type: "Link",
                    destination: item.path ?? null,
                  });
                  onClick(e, item);
                }}
                className="text-link cursor-pointer text-left"
                aria-label={text}
              >
                <TextElement
                  text={text}
                  className={cn("text-master-primary-default body--large", styles.textLink)}
                />
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

// Set display name for easier debugging
LinkedItemsComponent.displayName = "LinkedItems";

// Wrap with memo
const LinkedItems = memo(LinkedItemsComponent);

export default LinkedItems;
